export default __webpack_public_path__ + "static/media/owl.97f7b6f2.svg";